class BESSAppProjectReportAPIService extends BESSAppAPIServiceBase {

    constructor(parent) {
        super(parent, 'report/');
    }

    reportStatus(publishing, onSaved, onError = null) {
        this._post(
            'report-status',
            {
                data: {
                    'publishing': publishing,
                },
                onResult: onSaved,
                onError: onError,
            }
        )
    }

    prepareReport(onSaved, onError = null) {
        this._post(
            'prepare-report',
            {
                data: {},
                onResult: onSaved,
                onError: onError,
            }
        )
    }

    reportPDFStatus(publishing, onSaved, onError = null) {
        this._post(
            'report-pdf-status',
            {
                data: {
                    'publishing': publishing,
                },
                onResult: onSaved,
                onError: onError,
            }
        )
    }

    saveChart(chartId, chartData) {
        this._post(
            'save-chart',
            {
                data: {
                    'chart_id': chartId,
                    'chart_data': chartData,
                }
            }
        );
    }

    publishProject(data, onSaved, onError = null) {
        this._post(
            'publish',
            {
                data: data,
                onResult: onSaved,
                onError: onError,
            }
        );
    }

    publishStatus(onSaved, onError = null) {
        this._post(
            'publish-status',
            {
                data: {},
                onResult: onSaved,
                onError: onError,
            }
        )
    }

}